import { SubscriptionWithPlansAndAccess } from "@syla/shared/types/responses/GetSubscriptionsResponse";
import React, { Fragment } from "react";
import { canManageExistingSubscription } from "../../../helper/permissions";
import { useCurrentAccountStore } from "../../../store/currentAccountStore";
import { Plan } from "../../../types/plans/plan";
import { User } from "../../../types/user/user";
import { PlanRenewalDate } from "./PlanRenewalDate";
import { SubscriptionAlert } from "./SubscriptionAlert";
import { SubscriptionPlanDetails } from "./SubscriptionPlanDetails";
import { TransactionCap } from "./TransactionCap";
import { useSubscriptionActions } from "./useSubscriptionActions";

export const SubscriptionDetails = ({
  subscription,
  downgradePlan,
  isRedirecting,
  setIsRedirecting,
  user,
}: {
  subscription?: SubscriptionWithPlansAndAccess;
  downgradePlan: Plan | undefined;
  isRedirecting: boolean;
  setIsRedirecting: (value: boolean) => void;
  user: User;
}) => {
  const accountId = useCurrentAccountStore(({ accountId }) => accountId);

  const { openMainPortal } = useSubscriptionActions({
    currentSub: subscription,
    accountId,
    setIsRedirecting,
  });

  const canManageSubscription =
    !!subscription &&
    !!subscription.stripeSubscriptionId &&
    canManageExistingSubscription({
      subscriptions: [subscription],
    });

  return (
    <>
      <SubscriptionAlert
        canManageExistingSubscription={canManageSubscription}
        subscription={subscription}
        downgradePlan={downgradePlan}
        isRedirecting={isRedirecting}
        onManageBillingAction={openMainPortal}
      />
      <SubscriptionPlanDetails
        accountId={accountId}
        canManageExistingSubscription={canManageSubscription}
        subscription={subscription}
        isSuperUser={!!user.isSuperUser}
      />
      <PlanRenewalDate subscription={subscription} />
      <TransactionCap subscription={subscription} />
    </>
  );
};
